module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAJlJREFUSA1jYBgFwz4EGIn0oSZQXTia2tVA/lU0MQwuPgv6gKoVoDpsgbQIlA2j3gEZB6GcB0C6CMommroIVPmfSAxSixXg8wFIgx5WXZiClzCFICKELAD5gBiA0xwmYnRTombUAoKhNxpEgz+IiMloeNUQiuQdBMOAgQGvGpxZHGowL5COBGJJHBY9B4ovB+LPOORHhQmHAADzQBogHnFM5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/carData/img/delete.png
// module id = 1702
// module chunks = 0